/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_GreekInputs */



/**
* | output |
* | --- |
* | "Greek" |
*
* @param {Speechmatics_Target_Language_GreekInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_greek = /** @type {((inputs?: Speechmatics_Target_Language_GreekInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_GreekInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Grec")
	if (locale === "de") return /** @type {LocalizedString} */ ("griechisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("greco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("греческий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Griego")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("希腊语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ギリシャ語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यूनानी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("grego")
	return /** @type {LocalizedString} */ ("Greek")
});